import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  sidebar: {
    width: '20%',
  },
  content: {
    flex: 1,
    padding: '1.2rem',
    minWidth: 0,
  },
}));

export default useStyles;